import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "number",
    value: _ctx.value,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
    ref: "root"
  }, null, 40, _hoisted_1))
}